// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"29faf277","453":"f77124e5","512":"7c2297a7","611":"96def5ee","669":"17c7d3e1","868":"08cf1e10"}[chunkId] + ".chunk.js";
};